import { ReactElement, useEffect } from "react";
import Component404 from "../../components/Component404/Component404";
import { useGetPermissionQuery } from "../../store/api/permission.api";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setManager } from "../../store/slice/adminManagerSlice/adminManagerSlice";
import { EditManagerInfo } from "../../components/AdminManagerInfo/widgets/EditManagerInfo/EditManagerInfo";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import classes from "./PageManager.module.css";
import { useAppSelector } from "../../store/reduxHooks";

export function PageManager(): ReactElement {
  const { id } = useParams();
  const { data: permissionData } = useGetPermissionQuery(undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isEditForm = useAppSelector(
    (state) => state.adminManagerInfoSlice.isEditForm,
  );

  useEffect(() => {
    const getManagerFromPermission = permissionData?.data.manager.find(
      (el) => String(el.id) == id,
    );

    if (getManagerFromPermission) {
      dispatch(setManager(getManagerFromPermission));
    }
  }, [id]);

  if (!permissionData?.data.manager.find((el) => String(el.id) === id)) {
    return (
      <Component404
        backButtonLink="/list-manager"
        backButtonChild="Вернуться к списку менеджеров"
      />
    );
  }

  return (
    <div className={`${classes.container} ${isEditForm && classes.isEdit}`}>
      <Button
        onClick={() => navigate(-1)}
        className={classes.buttonBack}
        icon={<ArrowLeftOutlined className={classes.buttonBackIconArrow} />}
      >
        Назад
      </Button>
      <EditManagerInfo />
    </div>
  );
}
